import { render } from "./sentQueryListForAlert.vue?vue&type=template&id=132f0ddc"
import script from "./sentQueryListForAlert.vue?vue&type=script&lang=js"
export * from "./sentQueryListForAlert.vue?vue&type=script&lang=js"

import "./sentQueryListForAlert.vue?vue&type=style&index=0&id=132f0ddc&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__